
        import { createApi } from '@reduxjs/toolkit/query/react';
        import { createBaseQuery } from 'src/datahandling/redux/api/apiUtils';

        // Initialize an empty API service that we'll inject endpoints into later as needed
        export const insightsApi = createApi({
        reducerPath: 'insightsAutoGeneratedApi',
        baseQuery: createBaseQuery("INSIGHTS_API"),
        
        endpoints: () => ({}),
        });

        export type insightsApiType = typeof insightsApi;
        export default insightsApi;
    